var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransferArrows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3,12.3a1,1,0,1,1,1.4,1.4L7.4,15H19a1,1,0,0,1,0,2H7.4l1.3,1.3a1,1,0,0,1,0,1.4,1,1,0,0,1-1.4,0l-3-3a1,1,0,0,1,0-1.4Zm8-8a1,1,0,0,1,1.4,0l3,3a1,1,0,0,1,0,1.4l-3,3a1,1,0,0,1-1.4,0,1,1,0,0,1,0-1.4L16.6,9H5A.94.94,0,0,1,4,8,.94.94,0,0,1,5,7H16.6L15.3,5.7A1,1,0,0,1,15.3,4.3Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransferArrows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transfer-arrows.0ae07d7a67bbebce38cb64e73acaf637.svg";